
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/AuthProvider";
import { ZOHO_CALLBACK_ENDPOINT } from "../../config/urls";

const ZohoCallback = () => {
  const navigate = useNavigate();
  const { getValidToken } = useAuth();
  const hasRun = useRef(false);  // ensures effect only runs once

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const location = params.get("location");
    const accountsServer = params.get("accounts-server");
    const tenantId = localStorage.getItem("tenant");

    if (!code || !location || !accountsServer || !tenantId) {
      alert("❌ Missing required Zoho parameters or tenant ID.");
      return;
    }

    const fetchToken = async () => {
      try {
        const token = await getValidToken();
        const res = await fetch(ZOHO_CALLBACK_ENDPOINT, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Tenant-ID": tenantId,
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            code,
            location,
            accounts_server: accountsServer,
          }),
        });

        const data = await res.json();

        if (res.ok) {
          alert("✅ Zoho Connected Successfully");
          navigate("/");
        } else {
          console.error("❌ Zoho Error:", data);
          alert("❌ Failed to connect Zoho: " + (data.error || "Unknown error"));
        }
      } catch (err) {
        console.error("❌ Network error during Zoho connection:", err);
        alert("❌ Network error during Zoho connection.");
      }
    };

    fetchToken();
  }, [getValidToken, navigate]);

  return <p>🔄 Connecting to Zoho...</p>;
};

export default ZohoCallback;
